export default __webpack_public_path__ + "static/media/hero_shot.acedac9a.webp";